module.exports = __webpack_public_path__ + "img/icon_start.5cc39859.png";